import React, { Component } from "react";
import { reportFrontendError } from "../../../resources/js/core/utils/frontendErrorReporter";
class ErrorBoundary extends Component {
    state = {
        hasError: false,
        errorInfo: null,
        error: null,
    };

    static getDerivedStateFromError(error) {
        console.debug({ error });
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error: { ...error },
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        reportFrontendError(error, {
            source: "legacy",
            kind: "react",
            componentStack: errorInfo.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI

            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <code>
                        {this.state.error && this.state.error.toString()}
                    </code>
                    <details style={{ whiteSpace: "pre-wrap" }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo &&
                            this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
